export const locale = {
    lang: 'nl',
    data: {
      'ALERTS':{
        'OK':'OK'
      },
      'SHEDULE': {
        'ERROR_RE':'De herinneringsdatum kan niet vroeger zijn dan de lanceringsdatum',
        'TITLE1': 'Registreer de releasedatum',
        'TITLE2': 'Registreer herinnering',
        'TITLE3': 'Registreren sluiten',
        'ERR01':'De herinneringen kunnen niet ondergeschikt zijn dan de lanceringsdag',
        'ERR02':'De herinneringen kunnen niet groter zijn dan de sluitingsdag',
        'ERR03':'De herinneringen moeten tijdens het onderzoek',
        'ERR04':'je kunt maar 3 herinneringen hebben',
        'ERR05':'De datum kan niet lager zijn dan nu',
        'ERR06':'Je hebt vandaag al een e-mail gestuurd',
        'SUC01':'Herinnering opslaan',
        'SELECT_DATE': 'Kies een datum',
        'SAVE': 'Sparen',
        'RECORDATORIOS': 'Herinneringen',
        'RECORDATORIO': 'Herinneringen', // Campo nuevo
        'ERRORDATE':'De datum kan daar nu niet voor liggen', // Campo nuevo
        'SAMEDATE':'Het is niet toegestaan ​​de huidige datum te kiezen als de lanceringsdatum van het onderzoek',

        'LESSDAYS_T':'Weet u zeker dat u door wilt gaan?',
        'LESSDAYS_I':'U moet de lanceringsdatum van de enquête ten minste 15 dagen vóór de lancering plannen, zodat de medewerkers het volledige communicatieplan kunnen ontvangen.',
        'CONFLDATE_T':'Waarschuwing!',
        'CONFLDATE_I':'Als u doorgaat, kunt u de programmering van de startdatum van de enquête niet ongedaan maken.',
        'WARNING_FECHA_UPDATE':' U kunt de datum van vandaag of eerder niet selecteren ',
        'FECHA_UPDATE_WARNING':'Zorg ervoor dat u de sluitingsdatum wijzigt',
        'FECHA_UPDATE':'De sluitingsdatum is correct bijgewerkt',

        'FECHA': 'Datum',
        'AGREGAR': 'Toevoegen',
        'EDITAR': 'Bewerk',
        'COMPLETAR_PASO': 'Voltooi stap',
        'PASO_COMPLETADO': 'Stap voltooid',
        'LOCK':'Heropen stap',
        'UNLOCK':'Stap in proces',
        'SUBIRLOGO': 'Om uw enquête te maken, moet u uw bedrijfslogo uploaden',
        'ACEPTARREQUERIMIENTOS': 'Om uw enquête te maken, moet u de technische vereisten accepteren',
        'LOGOSSURVEY': 'Voor het maken van uw enquête is het noodzakelijk om eerst de benodigde logo(\'s) vast te stellen',

        'SELECCIONE_FECHA': 'Selecteer een datum',
        'DATE_REGISTERED': 'Lanceringsdatum succesvol geregistreerd',
        'CLOSE_REGISTERED': 'Sluitingsdatum succesvol geregistreerd',
        'CLOSE_MSJ1': 'De sluitingsdatum moet langer zijn dan de releasedatum',
        'CLOSE_MSJ2': 'Voordat u zich registreert, moet u de releasedatum registreren ',
        'REMIDEROK': 'Herinnering correct geregistreerd',
        'REMIDERUPDAOK': 'Herinnering succesvol bijgewerkt',
        'AVIUPDAOK': 'Naar behoren bijgewerkte kennisgeving',
        'REMIDER_MSJ1': 'De herinnering moet groter zijn dan de releasedatum',
        'REMIDER_MSJ2': 'Voordat u een herinnering registreert, moet u de releasedatum registreren',
        'ESPERA_ENCUESTA': 'Wacht, dit kan een paar minuten duren.',

        'ENCUESTA': 'Enquête',
        'CREANDO_ENCUESTA': 'Enquête maken ...',
        'AGREGANDO_USUARIOS': 'Gebruikers toevoegen ...',
        'AGREGANDO_SECCION1': 'NPS toevoegen aan de enquête ...',
        'AGREGANDO_SECCION2': 'STATEMENTS toevoegen aan de enquête ...',
        'AGREGANDO_SECCION3': 'CONTROL toevoegen aan de enquête ...',
        'AGREGANDO_SECCION4': 'DEMOGRAPHICS toevoegen aan de enquête ... ',
        'AGREGANDO_SECCION5': 'EXTRA aan de enquête toevoegen ...',
        'AGREGANDO_SECCION6': 'FORALL aan de enquête toevoegen ...',
        'AGREGANDO_SECCION7': 'Open vragen toevoegen aan de enquête ...',
        'REINTENTAR': 'Probeer het opnieuw',
        'ERROR_ENCUESTA': 'Fout bij maken van enquête',
        'ERROR_USUARIOS': 'Fout bij het toevoegen van gebruikers ...',
        'ERROR_SECCION1': 'Fout bij toevoegen van NPS aan enquête ...',
        'ERROR_SECCION2': 'Fout bij het toevoegen van STATEMENTS aan de enquête ...',
        'ERROR_SECCION3': 'Fout bij toevoegen van CONTROL aan enquête ...',
        'ERROR_SECCION4': 'Fout bij het toevoegen van DEMOGRAPHICS aan de enquête ...',
        'ERROR_SECCION5': 'Fout bij het toevoegen van ADDITIONAL aan de enquête ...',
        'ERROR_SECCION6': 'Fout bij het toevoegen van FORALL aan enquête ...',
        'ERROR_SECCION7': 'Fout bij toevoegen van open vragen aan enquête ...',

        'SUCCESS_ENCUESTA': 'Enquête succesvol gemaakt!',
        'SUCCESS_USUARIOS': 'Gebruikers succesvol toegevoegd!',
        'SUCCESS_SECCION1': 'NPS succesvol toegevoegd aan de enquête!',
        'SUCCESS_SECCION2': 'STATEMENTS succesvol toegevoegd aan de enquête!',
        'SUCCESS_SECCION3': 'CONTROLEVRAAG succesvol toegevoegd aan de enquête!',
        'SUCCESS_SECCION4': 'DEMOGRAPHICS succesvol toegevoegd aan de enquête!',
        'SUCCESS_SECCION5': 'AANVULLINGEN met succes toegevoegd aan de enquête!',
        'SUCCESS_SECCION6': 'VOOR ALLE succesvol toegevoegd aan de enquête!',
        'SUCCESS_SECCION7': 'Open vragen met succes toegevoegd aan de enquête!',
        'BTN_CREARENCUESTA': 'Maak een enquête',

        'CONTINUE_FINISH': 'Enquête succesvol gemaakt, u kunt de stap voltooien.',
        'LAUNCH_SURVEY': 'Maak de enquête aan om de stap te voltooien',
        'PULSE':{
            //Shedule survey
          'MES1': ' Pulse Check maand 1',
          'MES2': ' Pulse Check maand 2',
          'MES3': ' Pulse Check maand 3',
          'MES4': ' Pulse Check maand 4',
          'MES5': ' Pulse Check maand 5',
          'MES6': ' Pulse Check maand 6',
          'MES7': ' Pulse Check maand 7',
          'MES8': ' Pulse Check maand 8',
          'MES9': ' Pulse Check maand 9',
          'MES10': ' Pulse Check maand 10',
          'MES11': ' Pulse Check maand 11',
          'MES12': ' Pulse Check maand 12',
          'INDICA': 'Selecteer de pulscontroledatum',
          'INDICA_GENERA':'Genereer een enquête',
          'SUBINDICA_GENERA':'Klik om een ​​enquête te genereren',
        },

      },
      'SHEDULE2_0': {
        'CARDS': {
          'ERROR':'De herinneringsdatum kan niet vroeger zijn dan de lanceringsdatum',
          'PASO1': {
            'TITULO': 'Vereisten',
            'INFO_PRE': 'U moet aan deze voorwaarden voldoen voordat u de enquête maakt',
            'INFO_POST': 'U hebt al aan de voorwaarden voldaan om de enquête te maken',
            'REQTEC': 'Technische benodigdheden',
            'REQTEC_TOOLTIP': 'Ga naar technische vereisten',
            'LOGO': 'Bedrijfslogo',
            'LOGO_TOOLTIP': 'Klik om het logo te laden',

          },
          'PASO2': {
            'TITULO': 'Publicatiedatum',
            'TITULO_CIERRE': 'Sluitingsdatum',
            'INFO_PRE': 'Selecteer en noteer de startdatum voor de enquête',
            'INFO_POST': 'Geselecteerde datum',
            'PICKDATE': 'Kalender openen',
            'INFO_POST_CIERRE': 'Huidige sluitingsdatum',
            'CHANGE': 'Verander de datum',
            'LIS-PRORRO':' extensies ',
          },
          'PASO2_B': {
            'TITULO': 'Datum selectie',
            'INFO_PRE': 'Selecteer en registreer de verschillende beschikbare data om de enquête te configureren',
            'PICKDATE': 'Kies datums',
            'INFO_PROR': 'Er zijn extensies toegewezen aan dit product',
            'PRORROGAS': 'Zie extensies',
            'TIUTLOLISTA': 'Extensies gemaakt',
            'NOPROR': 'U heeft geen toegewezen extensies'
          },
          'PASO3': {
            'TITULO': 'Herinneringen',
            'INFO_PRE': 'Voeg datums voor het indienen van herinneringen toe om de enquête te beantwoorden',
            'INFO_POST': 'U heeft twee mogelijkheden:',
            'NUEVO': 'Registreer een nieuwe herinnering',
            'LISTA': 'Aufgezeichnete Erinnerungen',
            'LISTA_AVI': 'Kommunikation vor der Erhebung',
            'TITU_AVIS':'advertenties',
            'TIUTLOLISTA': 'Herinneringen gemaakt',
            'NORECOS': 'U heeft geen herinneringen opgeslagen',
            'NOAVI': 'U hebt geen waarschuwingen opgeslagen',
            'INFOHORA': 'OPMERKING: elke herinnering wordt weergegeven in de lokale tijd van het instituut: ',
            'INFOHORAAVISO': 'OPMERKING: Elke aankondiging wordt weergegeven in de lokale tijd van het instituut:',
            'TITULOLISTA': 'Opgestelde aankondigingen',
          },
          'PASO4': {
            'TITULO': 'Communicatieberichten',
            'INFO_PRE': 'Bekijk de communicatieberichten die tijdens de levenscyclus van het onderzoek moeten worden verzonden',
            'VERMENSAJES': 'Zie communicatieberichten'
          },
          'PASO5': {
            'TITULO': 'Onderzoekscontrole',
            'TITULO_ALT': 'Hoofdtabelcontrole',
            'INFO_PRE': 'Bekijk de secties van de enquête, evenals het aantal vragen dat in elke sectie is toegevoegd',
            'VERMENSAJES': 'Zie sectiegegevens',
            'FILTRAR': 'Secties filteren op naam',
            'TABLE':{
              'SECTION': 'Sectie',
              'VALUE': 'Waarde',
              'INACTIVE':'Inactief',
              'ACTIVE':'Actief',
              'CLOSE':'Gesloten'
            }
          },
          'PASO6': {
            'TITULO': 'Geschiedenis van het genereren van enquêtes',
            'INFO_PRE': 'Datum laatste enquête:',
            'INFO_PRE_2': 'Generatiegeschiedenis:',
            'ERRORHISTORIAL':'U heeft uw geschiedenis niet omdat de enquête niet is gemaakt'
          },
          'PASO7': {
            'TITULO': 'Enquêtekenmerken',
            'INFO_PRE': 'Voordat u de enquêtefuncties configureert, moet u eerst aan de vereisten voldoen',
            'INFO_POST_1': 'Voordat u de enquête maakt, moet u de kenmerken van de enquête configureren',
            'INFO_POST_2': 'U heeft al de nodige instellingen ingesteld om de enquête te maken',
            'EMPRESA': 'Bedrijfslogo',
            'CERTIFICADO': 'Certificaatlogo',
            'CARACTERISTICAS': 'Enquêtekenmerken',
            'PREVIEW': 'Voorbeeld',
            'CAMBIAR': 'Afbeelding wijzigen',
            'LOGO_EMP_INFO': 'De afbeelding wordt weergegeven in de opgeslagen resolutie, 200x200 pixels'
          },
          'MODALGEN': {
            'REGRESAR': 'Ga terug',
            'HISTORIAL': {
              'BOTON': 'Geschiedenis van het genereren van enquêtes',
              'TITULO': 'Geschiedenis van het genereren van enquêtes',
              'CARGANDO': 'Generatiegeschiedenis laden',
              'ULTIMA': 'Datum laatste generatie',
              'ANTERIORES': 'Datums vorige generatie generation',
              'NOHISTO': 'Er is geen geschiedenis van het genereren van de enquête'
            },
            'CERTIFICADO': {
              'TITULO': 'Certificaatvoorbeeld'
            },
            'URL_QR': {
              'BOTON': 'Krijg link in QR-code',
              'TITULO': 'Enquêtelink in QR-code',
              'SUBTITULO': 'Door deze QR-code te scannen, krijgt u direct toegang tot de enquête zonder de link handmatig in te voeren',
              'DESCARGA': 'Om de QR-code te downloaden, klikt u met de rechtermuisknop op de afbeelding en vervolgens op de optie <b> <em> Afbeelding opslaan als ... </em> </b>',
              'REGENERARQR': 'De URL is correct gewijzigd. Als u een QR-code van de vorige URL heeft, moet u een nieuwe QR-code krijgen met de bijgewerkte link'
            }
          },
          'STATUS': {
            'PENDING': 'Nog niet compleet',
            'OK': 'Klaar',
            'OPT': 'Deze stap is optioneel'
          },
          'FECHAS': {
            'TITULO': 'Datum selectie',
            'FECHA': 'Geselecteerde datum:',
            'NOTYET': 'Nog niet gekozen',
            'INFO': {
              '1': 'Selecteer elk van de beschikbare datums om de enquête te configureren.',
              '2': 'OPMERKING: de tijd die op elke datum is geselecteerd, is ingesteld op de lokale tijd van het instituut: '
            },
            'TABLA': {
              'TIPO': 'Type datum',
              'FECHA': 'Geselecteerde datum',
              'ACCIONES': 'Acties'
            },
            'TIPOS': {
              'lanzamiento': 'Lanceerdatum',
              'aviso1': 'Pre-lancering (eerste melding vóór lancering van het onderzoek)',
              'aviso2': 'Pre-lancering (tweede melding voordat de enquête wordt gelanceerd)',
              'cierre': 'Deadline',
              'recor30': 'Voor de lancering (Aankondiging 30 dagen voor de enquête)',
              'recor29': 'Voorintroductie (kennisgeving 29 dagen voor de enquête)',
              'recor15': 'Voorintroductie (kennisgeving 15 dagen voor de enquête)',
              'recor7': 'Voor de lancering (kennisgeving 7 dagen voor de enquête)',
              'result': 'Resultaten:',
            },
            'BOTONES': {
              'ELEGIR': 'Kies een datum',
              'CAMBIAR': 'Verander de datum',
              'CANCELAR': 'Annuleren',
              'ACEPTAR': 'Aanvaarden',
              'ENVIOCIERRE': 'Send notification'
            }
          }
        },
        'CREAR': 'Maak een enquête',
        'RECREAR': 'Maak een enquête opnieuw',
        'ENCUESTACREADA': 'Enquête gemaakt',
        'ENCUESTAERROR': 'De enquête is niet correct gemaakt',
        'VERSECCIONES': 'Zie toegevoegde secties',
        'BACK': 'Terug',
        'CERRAR': 'Dichtbij',
        'CREANDO': 'De enquête wordt gemaakt, wacht tot elk van de componenten correct is toegevoegd',
        'RETRY': 'Probeer het proces opnieuw',
        'SECCIONES': {
          'DETALLES': 'Laatste details opslaan',
          'COMPLETA': 'De enquête is met succes aangemaakt! ',
          'ENCUESTA': {
            'TITULO': 'Enquête',
            'PROCESO': 'Enquête maken',
            'ERROR': 'Er is een fout opgetreden bij het maken van de enquête, probeer het proces opnieuw'
          },
          'USUARIOS': {
            'TITULO': 'Users',
            'PROCESO': 'Gebruikers toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van de gebruikers, probeer het proces opnieuw',
          },
          'NPS': {
            'TITULO': 'NPS',
            'PROCESO': 'NPS toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van NPS. Probeer het opnieuw',
          },
          'REACTIVOS': {
            'TITULO': 'Verklaringen',
            'PROCESO': 'Uitspraken toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van de instructies. Probeer het proces opnieuw',
          },
          'CONTROL': {
            'TITULO': 'Controle vraag',
            'PROCESO': 'Controle vraag toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van de controlevraag, probeer het proces opnieuw',
          },
          'DEMOGRAFICOS': {
            'TITULO': 'Demografie',
            'PROCESO': 'Demografie toevoegen aan de enquête ',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van de demografische gegevens. Probeer het opnieuw',
          },
          'ABIERTAS': {
            'TITULO': 'Open vragen',
            'PROCESO': 'Open vragen toevoegen aan de enquête ',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van open vragen, probeer het proces opnieuw',
          },
          'FORALL': {
            'TITULO': 'Voor iedereen',
            'PROCESO': 'ForAll-praktijken toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van de ForAll-procedures, probeer het proces opnieuw ',
          },
          'ADICIONALES': {
            'TITULO': 'Extra',
            'PROCESO': 'Extra vragen toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van aanvullende vragen. Probeer het proces opnieuw',
          },
          'ADICIONALES-FOCUS': {
            'TITULO': 'Gepersonaliseerd',
            'PROCESO': 'Aangepaste vragen toevoegen aan de enquête',
            'ERROR': 'Er is een fout opgetreden bij het toevoegen van de aangepaste vragen. Probeer het proces opnieuw',
          },
        },
        'MODALES': {
          'ENCUESTA': {
            'CREAR_1': 'Wilt u de enquête maken met de huidige configuratie?',
            'CREAR_2': 'Zodra de enquête is gemaakt, kunt u de communicatieberichten niet meer wijzigen',
            'CREAR_3': 'Wilt u beginnen met het maken van de enquête?',
            'SINFECHA': 'Om de enquête te maken, moet u eerst de lanceringsdatum ervan kiezen',
            'CREADA_1': 'De enquête is met succes aangemaakt!',
            'CREADA_2': 'U kunt deze sectie nu voltooien en doorgaan met de volgende',
            'RECOEXIS': 'Er is al een geregistreerde herinnering voor de geselecteerde dag',
            'RECOBEFORE': 'U kunt geen herinnering opnemen zonder eerst de startdatum van het onderzoek te kiezen',
            'RECOMAX': 'Je hebt al alle toegestane herinneringen geprogrammeerd, je kunt geen nieuwe meer registreren',
            'LASTRECO_1': 'Waarschuwing:',
            'LASTRECO_2': 'U heeft alle toegestane herinneringen ingepland, u kunt geen nieuwe herinneringen meer registreren',
            'LISTARECOBEF': 'U kunt de herinneringslijst niet bekijken zonder eerst de startdatum van het onderzoek te kiezen',
            'FINAL': 'U kunt deze sectie nu voltooien en doorgaan met de volgende',
            'SAVELAUNCHDATE': 'De lanceringsdatum van de enquête wordt opgeslagen. Een ogenblik geduld',
            'SAVEAVISODATE': 'De meldingsdatum opslaan, even geduld',
            'AVISOOK': 'De meldingsdatum is succesvol opgeslagen',
            'CHANGELAUNCH': 'Waarschuwing: als u de lanceringsdatum van de enquête wijzigt, worden de rest van de datums gewist en moet u ze opnieuw selecteren. Wilt u een andere lanceringsdatum kiezen?',
            'CHANGECLOSENOT': 'De verzendstatus van de melding is succesvol gewijzigd',
            'GUARDANDO_LOGO': 'Afbeelding opslaan, wacht even',
            'CARGA_CERT': 'Om de hoogste kwaliteit in het uiteindelijke document te krijgen, moet u een afbeelding uploaden met een minimale resolutie van 400 x 240 pixels.',
            'BORRA_RECO_1': 'Weet je zeker dat je de herinnering met de volgende datum wilt verwijderen?',
            'BORRA_RECO_2': 'De herinnering is succesvol verwijderd',
            'BORRA_AVI_1': 'Weet u zeker dat u de herinnering met de volgende datum wilt verwijderen?',
            'BORRA_AVI_2': 'De herinnering werd met succes herinnerd',
            'UPDA_AVISO': 'Herinnerdatum bijwerken',
            'UPDA_RECOR':'Herinnerdatum bijwerken',
            'DELE_AVISO': 'Aanmaningsdatum verwijderen',
            'DELE_RECOR': 'Aanmaningsdatum verwijderen',
            'GUARD_RECOR': 'Opslaan herinneringsdatum',
            'TITL_MOD_QUES_ALEAT':'Om de enquête te maken is het noodzakelijk om de willekeurige vraagvalidatie in te schakelen.',
            'TEXT_MOD_QUES_ALEAT_1':'Volg dan deze stappen:',
            'TEXT_MOD_QUES_ALEAT_2':'1.- Voer in bewerk de enquêtekenmerken in.',
            'TEXT_MOD_QUES_ALEAT_3':'2.- Klik op aanvullende configuratie en schakel de willekeurige vraagvalidatie in.',
          }
        },
        'CORREOS': {
          'VER': 'Zie bericht',
          'TIPO1': {
              'TITULO': 'Pre-lanceringsbericht',
              'INFO': 'Dit zijn de berichten die dagen vóór de lancering van de enquête zijn verzonden',
              'TIPO_1': 'Eerste notificatiebericht',
              'TIPO_2': 'Tweede meldingsbericht',
          },
          'TIPO2': {
              'TITULO': 'Uitnodigingsbericht',
              'INFO': 'Dit is het bericht dat naar medewerkers wordt gestuurd op de dag van de lancering van de enquête'
          },
          'TIPO3': {
              'TITULO': 'Herinneringsbericht',
              'INFO': 'Dit is het herinneringsbericht dat wordt verstuurd op de dagen die hiervoor zijn ingepland.'
          },
          'TIPO4': {
              'TITULO': 'Eerste notificatiebericht',
              'INFO': ''
          },
          'TIPO5': {
              'TITULO': 'Tweede meldingsbericht',
              'INFO': ''
          },
          'TIPO6': {
              'TITULO': 'Onderzoek sluit bericht',
              'INFO': 'Dit is het bericht dat naar medewerkers wordt gestuurd op de sluitingsdatum van de enquête \n OPMERKING: het wordt alleen verzonden als het is geactiveerd'
          },
          'TIPO7': {
            'TITULO': 'Bericht aan medewerkers die hun enquête nog niet zijn gestart',
            'INFO': 'Dit is het herinneringsbericht dat wordt verzonden naar bijdragers die hun enquête nog niet hebben gestart'
          },
          'TIPO8': {
            'TITULO': 'Bericht aan bijdragers die nog niet klaar zijn',
            'INFO': 'Dit is het herinneringsbericht dat wordt verzonden naar bijdragers die al aan hun enquête zijn begonnen, maar nog niet zijn voltooid'
          },
        },
        'EDITOR': {
          'BOTONES': {
            'INFO': 'Important information',
            'SAVE': 'Wijzigingen opslaan',
            'EDIT': 'Bewerk bericht',
          },
          'PENDING': 'In validatieproces',
          'MODALINFO': {
            'TITULO': 'Belangrijke informatie over de inhoud van de e-mail',
            'PARTE_1': 'Om ervoor te zorgen dat de e-mail als correct wordt verzonden, kunnen de volgende labels worden opgenomen in de hoofdtekst van het bericht (let op, de verplichte labels moeten minstens één keer worden toegevoegd):',
            'PARTE_2': 'De reden hiervoor is te wijten aan het feit dat wanneer de bezorgdatum van elke e-mail arriveert, het platform automatisch de volgende vervangingen in het bericht uitvoert:',
            'tag_company': 'De bedrijfsnaam',
            'tag_link': 'De toegangslink naar de enquête',
            'tag_date': 'De lanceringsdatum van de enquête',
            'tag_user': 'Enquêtetoegangswachtwoord',
            'tag_dtb': 'Dagen tot de lancering van de enquête (vanaf de datum waarop het bericht is verzonden)',
            'tag_dtc': 'Dagen tot het einde van de enquête (vanaf de datum waarop het bericht is verzonden)',
            'tag_end': 'De sluitingsdatum van de enquête',
            'tag_userAction': 'Gebruiker om in te loggen',
            'tag_pass': 'Wachtwoord van de gebruiker',
            'tag_linkAction': 'De toegangslink naar cultrural Go',
            'PARTE_3': 'Labels kunnen overal in de hoofdtekst van de e-mail worden geplaatst. Zodra de tags aanwezig zijn in de inhoud, kan deze worden opgeslagen.',
            'PARTE_4': 'Let op: het is mogelijk dat het bericht gevalideerd moet worden door een projectmanager, als dit het geval is, kun je op dit scherm de validatiestatus van de nieuwe e-mail zien. Tijdens het validatieproces kunt u geen nieuwe editie van de e-mail maken. Anders wordt de e-mail onmiddellijk als geldig beschouwd en kunt u deze desgewenst opnieuw bewerken.',
            'OPC': '(Optioneel)',
            'MDT': '(Verplicht, behalve in het afsluitbericht)'
          },
          'MODALES': {
            'SINCAMBIOS': 'U heeft nog geen wijzigingen aangebracht in de inhoud van de e-mail',
            'SINTAG': 'Kan e-mail niet opslaan, de volgende tag is niet gevonden:',
            'GUARDAR_1': 'Wilt u de wijzigingen in het bericht opslaan?',
            'GUARDAR_2': 'We herinneren u eraan dat het ter validatie wordt verzonden en dat u het niet opnieuw kunt bewerken totdat het validatieproces is voltooid. ',
            'SAVEOK_1': 'De inhoud van de e-mail is correct opgeslagen',
            'SAVEOK_2': 'Wacht tot een projectmanager de wijzigingen valideert ',
            'ENABLED': 'Een projectmanager heeft het bewerken van e-mail opnieuw geactiveerd, u kunt doorgaan met het aanbrengen van wijzigingen',
            'CAMBIOIDIOMA_1': 'Let op: als u een andere taal wilt kiezen, moeten de wijzigingen die tot dusver in de huidige taal zijn aangebracht, eerst worden opgeslagen',
            'CAMBIOIDIOMA_2': 'Wilt u de wijzigingen opslaan en een andere taal kiezen?',
          }
        },
        'ZONAS': {
          '1': 'Mexico Stad',
          '2': 'San Salvador',
          '3': 'Hong Kong',
          '4': 'Singapore',
          '5': 'Istanbul',
          '6': 'Manila',
          '11': 'Brasilia',
          '15': 'Madrid',
          '18': 'Mexico Stad',
        },
        'SECCIONES_ESPECIALES': {
          'TITULO': 'Deze enquête heeft speciale secties',
          'SUBTITULO': 'Hieronder staan de demo-gebruikers gegroepeerd, elke groep is bedoeld om de enquête met elke speciale sectie afzonderlijk te testen, of de enquête zonder speciale secties',
          'ELEGIR': 'Selecteer een groep in het menu aan de linkerkant',
          'LISTA': {
            'TITULO': 'speciale secties',
            'SIN_SECCION': 'Enquête zonder speciale secties'
          }
        },
        'CORREOS_NORM':{
          'TIPO1':{
            'TITULO': 'Pre-lanceringsbericht',
            'INFO': 'Dit zijn de berichten die dagen vóór de lancering van de enquête zijn verzonden',
          },
          'TIPO2':{
            'TITULO': 'Waarschuwingsbericht: 30 dagen voor de lancering van de uitnodiging' ,
            'INFO': 'Dit zijn de berichten die dagen voor de lancering van de enquête worden verstuurd'
          },
          'TIPO3':{
            'TITULO': 'Waarschuwingsbericht: 29 dagen voor de lancering van de uitnodiging',
            'INFO': 'Dit zijn de berichten die dagen voor de lancering van de enquête worden verstuurd'
          },
          'TIPO4':{
            'TITULO': 'Waarschuwingsbericht: 15 dagen voor de lancering van de uitnodiging',
            'INFO': 'Dit zijn de berichten die dagen voor de lancering van de enquête worden verstuurd'
          },
          'TIPO5':{
            'TITULO': 'Waarschuwingsbericht: 7 dagen voor de lancering van de uitnodiging',
            'INFO': 'Dit zijn de berichten die dagen voor de lancering van de enquête worden verstuurd'
          },
          'TIPO6': {
              'TITULO': 'Onderzoek sluit bericht',
              'INFO': 'Dit is het bericht dat naar medewerkers wordt gestuurd op de sluitingsdatum van de enquête \n OPMERKING: het wordt alleen verzonden als het is geactiveerd'
          },
          'TIPO7':{
            'TITULO': 'Herinneringsbericht',
            'INFO': 'Dit is het herinneringsbericht dat wordt verstuurd op de dagen die hiervoor zijn ingepland.'
          },
        }
      }
    }
};
